import React, { useState, useMemo, useEffect, useRef } from "react";
import moment from "moment";
import A12Y_CONST from "../common/a12yConst";
import DependentCard from "./DependentCard";
import PopUpWelcomeAdvocord from "./PopUpWelcomeAdvocord";
import PopUpUserSurvey from "./PopUpUserSurvey";
import PopUpQuikConsult from "./PopUpQuikConsult";
import ErrorMessageComponent from "./ErrorMessageComponent";
import PopUpComponent from "./PopUpComponent";


function SearchIcon() {
  return (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="10.5" cy="10.5" r="7.5" stroke="#B0B7C3" strokeWidth="2" />
      <line x1="16" y1="16" x2="21" y2="21" stroke="#B0B7C3" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

function AllDependentsDashboardComponent({
  dependentList = [],
  loading = false,
  onNavigate,
  onAddDependent,
  isQuotaFull,
  isQuotaExceeded,
  shouldDisable,
  userInfo,
  dependent,
  detailsRoute,
  selectedDependentId,
  refreshList,
  totalAllowed,
  currentCount,
  subscriptionType,
  subscription,
  userSubscriptionAllDetails,
  welcomePopUpStatus,
  isTrialReminder,
  IsSurveyRolePopUp,
  IsSurvey_PopUp,
  welcomePopUpClose,
  surveyPopUpHandle,
  surveySectionVisible,
  handleSurvey,
  activationFee,
  excemptAllFee,
  trialReminderBoxHide,
  billingScreenHandle,
  dashboardError,
}) {
  const normalizedList = useMemo(() => {
    return (dependentList || []).map(item => item.obj || item);
  }, [dependentList]);

  const [isPopUp, setIsPopUp] = useState(false);
  const [isNewPopUp, setIsNewPopUp] = useState(false);
  const [isPopUpQuickConsult, setIsPopUpQuickConsult] = useState(false);
  const [popUpType, setPopUpType] = useState("OVERLOAD");
  const [showPaymentWarning, setShowPaymentWarning] = useState(false);
  const [search, setSearch] = useState("");
  const [filterStatus, setFilterStatus] = useState("active");
  const [isSortOpen, setIsSortOpen] = useState(false);
  const [sortOption, setSortOption] = useState("last_modified");
  const [sortDirection, setSortDirection] = useState("desc");
  const [pageError, setPageError] = useState("");
  const [showCancelSubscriptionAtWindowEndPopup, setShowCancelSubscriptionAtWindowEndPopup] = useState(false);
  
  const sortRef = useRef(null);

  useEffect(() => {
    if (dashboardError) {
      setPageError(dashboardError);
    }
  }, [dashboardError]);

  useEffect(() => {
    if (!pageError) return;
    const timer = setTimeout(() => setPageError(""), 5000);
    return () => clearTimeout(timer);
  }, [pageError]);
  const lastUserIdRef = React.useRef(userInfo?.id);

  useEffect(() => {
    if (!isSortOpen) return undefined;

    const handleClickOutside = (event) => {
      if (sortRef.current && !sortRef.current.contains(event.target)) {
        setIsSortOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isSortOpen]);

  if (userInfo?.id && lastUserIdRef.current !== userInfo.id) {
    lastUserIdRef.current = userInfo.id;
    setHasDismissedAutomaticPopUp(false);
    sessionStorage.removeItem('hasDismissedDashboardPopUp');
  }
  const [hasDismissedAutomaticPopUp, setHasDismissedAutomaticPopUp] = useState(sessionStorage.getItem('hasDismissedDashboardPopUp') === 'true');

  useEffect(() => {
    if (userInfo.last_login_time === null) {
      setIsPopUp(welcomePopUpStatus);
    }
  }, [welcomePopUpStatus, userInfo.last_login_time]);

  const filtered = useMemo(() => {
    const list = normalizedList.filter((dep) => {
      const fullName = `${dep?.first_name || ""} ${dep?.last_name || ""}`.toLowerCase();
      const caseNumberStr = (dep?.case_file_num || "").toLowerCase();

      const matchSearch =
        !search ||
        fullName.includes(search.toLowerCase()) ||
        caseNumberStr.includes(search.toLowerCase());

      const depStatus = (dep?.status || (dep?.is_active === false ? 1 : 0));
      const matchFilter =
        filterStatus === "all" ||
        (filterStatus === "active" && depStatus === 0) ||
        (filterStatus === "inactive" && depStatus !== 0);

      return matchSearch && matchFilter;
    });

    return list.sort((a, b) => {
      if (sortOption === "name") {
    const nameA = `${(a.last_name || "").toLowerCase()} ${(a.first_name || "").toLowerCase()}`.trim();
    const nameB = `${(b.last_name || "").toLowerCase()} ${(b.first_name || "").toLowerCase()}`.trim();

    return sortDirection === "asc"
      ? nameA.localeCompare(nameB)
      : nameB.localeCompare(nameA);
  } else {
        const dateA = new Date(a.updated_date || a.created_date || 0);
        const dateB = new Date(b.updated_date || b.created_date || 0);
        return sortDirection === "desc" ? dateB - dateA : dateA - dateB;
      }
    });
  }, [normalizedList, search, filterStatus, sortOption, sortDirection]);

 

  useEffect(() => {
    async function popUpStatus() {
      const isReadOnly = userInfo?.user_type === 1
      // Critical alerts: always show, regardless of dismissed flag
      if (!isReadOnly) {
      if (
        userSubscriptionAllDetails?.is_trial_expired ||
        dependent?.subscirption?.is_trial_expired
      ) {
        await setPopUpType(A12Y_CONST.LABEL.TRIAL_HAS_EXPIRED);
        await setIsPopUp(true);
        return;
      }
      if (userSubscriptionAllDetails?.subscription_details?.subscription_status === A12Y_CONST.TEXT.CANCELED || userSubscriptionAllDetails?.subscription_details?.subscription_status === A12Y_CONST.TEXT.PAST_DUE) {
        await setPopUpType(A12Y_CONST.LABEL.PURCHASED_PLAN_EXPIRED);
        await setIsPopUp(true);
        return;
      }
    }
 
      // Non-critical popups respect the dismissed flag
      if (hasDismissedAutomaticPopUp) return;
 
      if (!userInfo.last_login_time && welcomePopUpStatus) {
        await setPopUpType(A12Y_CONST.LABEL.WELCOME_TO_ADVOCORD);
        await setIsPopUp(true);
      }
 
      const subList = subscription || [];
      const allActiveDependent = (dependentList || []).filter(
        (d) => d.status === 0
      );
 
      // Calculate total quantity from active subscriptions
      const totalAllowedCount = userSubscriptionAllDetails?.price_details?.quantity
 
     
 
      const isTrialing = (Array.isArray(subList) ? subList : []).some(s => s.status === "trialing");
 
        
      if (!isReadOnly) {
      if (
        !isTrialing &&
        allActiveDependent.length > totalAllowedCount &&
        userSubscriptionAllDetails?.subscription_details?.subscription_status === A12Y_CONST.TEXT.ACTIVE_UPPER
      ) {
        await setPopUpType(A12Y_CONST.LABEL.QUOTA_LIMIT_REACHED);
        await setIsPopUp(true);
      }
    }
    }
    popUpStatus();
  }, [
    userInfo,
    dependent,
    userSubscriptionAllDetails?.is_trial_expired,
    userInfo.last_login_time,
    userSubscriptionAllDetails?.subscription_details?.subscription_status,
    subscriptionType,
    hasDismissedAutomaticPopUp,
    userInfo.id
  ]);

  const checkQuotaAndShowPopup = () => {
    const isReadOnly = userInfo?.user_type === 1;
    if (isReadOnly) return false;

    const subList = subscription || [];
    const allActiveDependent = (dependentList || []).filter(
      (d) => (d?.obj?.status ?? d?.status) === 0
    );

    // Calculate total quantity from active subscriptions
    const totalAllowedCount = userSubscriptionAllDetails?.price_details?.quantity || 0;
    const isTrialing = (Array.isArray(subList) ? subList : []).some(s => s.status === "trialing");

    if (
      !isTrialing &&
      allActiveDependent.length > totalAllowedCount &&
      userSubscriptionAllDetails?.subscription_details?.subscription_status === A12Y_CONST.TEXT.ACTIVE_UPPER
    ) {
      setPopUpType(A12Y_CONST.LABEL.QUOTA_LIMIT_REACHED);
      setIsPopUp(true);
      return true;
    }
    return false;
  };


   const goToBillingScreen = () => {

   
     const allActiveDependent = (dependentList || []).filter(
        (d) => d.status === 0
      );
    if (userSubscriptionAllDetails?.payment_method?.is_valid === false &&  totalAllowed <= allActiveDependent.length) {
      
      setShowPaymentWarning(true);
    } else if (
      (userSubscriptionAllDetails?.cancel_at_period_end || subscription?.cancel_at_period_end) && userSubscriptionAllDetails?.subscription_details?.subscription_status?.toLowerCase() === 'active'
    ) {
      setShowCancelSubscriptionAtWindowEndPopup(true);
    } else if (checkQuotaAndShowPopup()) {
      return;
    } else {
      onAddDependent();
    }
  };

  const hidePopUp = async () => {
    if (
      popUpType === A12Y_CONST.LABEL.TRIAL_HAS_EXPIRED ||
      popUpType === A12Y_CONST.LABEL.PURCHASED_PLAN_EXPIRED ||
      popUpType === A12Y_CONST.LABEL.QUOTA_LIMIT_REACHED
    ) {
      setHasDismissedAutomaticPopUp(true);
      sessionStorage.setItem('hasDismissedDashboardPopUp', 'true');
      welcomePopUpClose(false);
      if (popUpType === A12Y_CONST.LABEL.QUOTA_LIMIT_REACHED) {
        setIsPopUp(false);
        onNavigate(null, A12Y_CONST.ROUTE.DASHBOARD2);
      } else if (billingScreenHandle) {
        billingScreenHandle();
      } else {
        onNavigate(null, A12Y_CONST.ROUTE.ADVOCATE_PROFILE_MY_ACCOUNT);
      }
    } else {
      welcomePopUpClose(false);
      if (dependent?.access?.can_update) {
        setIsPopUpQuickConsult(true);
      }
    }
  };

  const hidePopUpQuickConsult = async () => {
    if (popUpType === A12Y_CONST.LABEL.WELCOME_TO_ADVOCORD) {
      setIsPopUpQuickConsult(false);
      if (dependent?.access?.can_update) {
        surveyPopUpHandle(true);
      }
    }
  };

  const closePopUP = () => {
    setHasDismissedAutomaticPopUp(true);
    sessionStorage.setItem('hasDismissedDashboardPopUp', 'true');
    welcomePopUpClose(false);
    setIsPopUp(false);
  };

  const skipSurveyPopUp = () => {
    surveyPopUpHandle(false);
  };

  const onHandleSurvey = (data) => {
    surveyPopUpHandle(false);
    handleSurvey(data);
  };

  return (
    <>
      {!userSubscriptionAllDetails?.is_trial_expired &&
        userSubscriptionAllDetails?.trial_period &&
        isTrialReminder ? (
       <div className="positionRelative zIndex2">
       <div className="freeTrialCountdown fullWidth">
          <span>
            {A12Y_CONST.LABEL.REMINDER}{" "}
            {userSubscriptionAllDetails?.subscription_details?.remaining_days}{" "}
            {A12Y_CONST.LABEL.DAYS_LEFT}
            {dependent?.access?.can_update ? (
              <span
                className="textDecoration cursorPointer paddingLeft1"
                onClick={() => onNavigate(null, A12Y_CONST.ROUTE.ADVOCATE_PROFILE_MY_ACCOUNT, { fromSubscriptionScreen: true })}
                id={A12Y_CONST.BUTTON_ID.SUBSCRIBETEXTID}
              >
                {A12Y_CONST.LABEL.SUBSCRIBE}
              </span>
            ) : null}
          </span>
          <span
            id={A12Y_CONST.BUTTON_ID.SUBSCRIBECLOSEID}
            className="cursorPointer"
            onClick={() => trialReminderBoxHide(false)}
          >
            <svg
              width="13"
              height="13"
              viewBox="0 0 13 13"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6.36401 4.9502L11.314 0L12.728 1.41016L7.77802 6.36011L12.728 11.3101L11.314 12.7202L6.36401 7.77002L1.414 12.7202L0 11.3101L4.95001 6.36011L0 1.41016L1.414 0L6.36401 4.9502Z"
                fill="white"
              />
            </svg>
          </span>
        </div>
        </div>
      ) : null}

      <div className="depDash__wrapper dashboardNew">
        {/* ── Page header ── */}
        <div className="depDash__page-header">
          <div className="fullWidth">
            
            <h2 class="titleWithSidebar marginBottom30  headerFixed df aic"><button class="cursorPointer backArrow bgTransparent borderNone  df aic" type="button"></button>All Dependents</h2>
            <p className="needToTalkText">
              {dependent?.access?.can_update ? 'Manage' : 'View'} assets, income, expenses, medical history and more for each dependent.
            </p>  

            {dependent?.access?.can_update && (
              <div className="depDash__need-to-talk-container">
                <div className="depDash__need-to-talk-icon">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
                  </svg>
                </div>
                <div className="depDash__need-to-talk-text">
                  <strong>Need to talk it through?</strong> Schedule a free{" "}
                  <a
                    href="https://calendly.com/nmeyersadvocord/30min?month=2024-10"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="depDash__need-to-talk-link"
                  >
                    30 min chat
                  </a>{" "}
                  for helpful tips and guidance.
                </div>
              </div>
            )}

            <div className="fullWidth positionRelative divHeigtht28 zIndex1">
              <div className="positionAbsoute fullWidth">
                {pageError ? <div className='maxWidth600 marginBottom40 marginLeftRightAuto'><ErrorMessageComponent errorMessage={pageError} /></div> : null}
              </div>
            </div>
          </div>
        </div>
        

        {/* ── Controls ── */}
        <div className="depDash__controls">
          <div className="depDash__sort-container" ref={sortRef}>
            <button
              className="depDash__sort-btn"
              onClick={() => setIsSortOpen(!isSortOpen)}
              type="button"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4 6H20M4 12H14M4 18H8" stroke="#2D6CB2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
              <span class="filterText ">Sort</span>
            </button>
            {isSortOpen && (
              <div className="depDash__sort-dropdown">
                <div className="depDash__sort-header">
                  <span>Sort by</span>
                  <button className="depDash__sort-close" onClick={() => setIsSortOpen(false)}>&times;</button>
                </div>
                <div className="depDash__sort-options">
                  <div
                    className={`depDash__sort-option ${sortOption === "last_modified" ? "active" : ""}`}
                    onClick={() => {
                      if (sortOption === "last_modified") {
                        setSortDirection(sortDirection === "asc" ? "desc" : "asc");
                      } else {
                        setSortOption("last_modified");
                        setSortDirection("desc");
                      }
                      setIsSortOpen(false);
                    }}
                  >
                    <span>Last Modified</span>
                    <svg
                      width="25" height="25" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                      style={{ transform: sortOption === "last_modified" && sortDirection === "asc" ? "rotate(180deg)" : "none", transition: "transform 0.2s" }}
                      onClick={(e) => {
                        e.stopPropagation();
                        if (sortOption === "last_modified") {
                          setSortDirection(sortDirection === "asc" ? "desc" : "asc");
                          setIsSortOpen(false);
                        }
                      }}
                    >
                      <path d="M12 4V14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                      <path d="M6 14L12 21L18 14H6Z" fill="none" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
                    </svg>
                  </div>
                  <div
                    className={`depDash__sort-option ${sortOption === "name" ? "active" : ""}`}
                    onClick={() => {
                      if (sortOption === "name") {
                        setSortDirection(sortDirection === "asc" ? "desc" : "asc");
                      } else {
                        setSortOption("name");
                        setSortDirection("asc");
                      }
                      setIsSortOpen(false);
                    }}
                  >
                    <span>Name (Last, First)</span>
                    <svg
                      width="25" height="25" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                      style={{ transform: sortOption === "name" && sortDirection === "asc" ? "rotate(180deg)" : "none", transition: "transform 0.2s" }}
                      onClick={(e) => {
                        e.stopPropagation();
                        if (sortOption === "name") {
                          setSortDirection(sortDirection === "asc" ? "desc" : "asc");
                          setIsSortOpen(false);
                        }
                      }}
                    >
                      <path d="M12 4V14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                      <path d="M6 14L12 21L18 14H6Z" fill="none" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
                    </svg>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="depDash__search-wrap">
            <span className="depDash__search-icon"><SearchIcon /></span>
            <input
              className="depDash__search"
              type="text"
              placeholder="Search by name or case number…"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
          <div className="depDash__filter-tabs">
            {["active", "inactive", "all"].map((f) => (
              <button
                key={f}
                className={`depDash__filter-tab${filterStatus === f ? " depDash__filter-tab--active" : ""}`}
                onClick={() => setFilterStatus(f)}
                type="button"
              >
                {f.charAt(0).toUpperCase() + f.slice(1)}
              </button>
            ))}
          </div>
          {dependent?.access?.can_update && (


            <button id="addExpense" onClick={goToBillingScreen} class="btn-primary saveButton plusIcon notToPrint "><span>+</span> <span>Dependent</span></button>
          )}
        </div>

        {/* ── Cards grid ── */}
        {loading ? (
          <div className="depDash__empty">
            <div className="positionRelative">
              <div className="dependentLoader">
                <div className='fullWidth justifyCenter marginBottom10'>
                  <div className="stage">
                    <div className="dot-pulse"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : filtered.length === 0 ? (
          <div className="depDash__empty">
            <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="30" cy="30" r="28" stroke="#E0E4EF" strokeWidth="2" />
              <circle cx="30" cy="22" r="8" stroke="#C5CBDA" strokeWidth="2" />
              <path d="M12 46c0-9.941 8.059-18 18-18s18 8.059 18 18" stroke="#C5CBDA" strokeWidth="2" strokeLinecap="round" />
            </svg>
            <p className="depDash__empty-text">
              {search || filterStatus !== "all"
                ? "No dependents match your search or filter."
                : "No dependents found."}
            </p>
          </div>
        ) : (
          <div className="depDash__grid">
            {filtered.map((dep, i) => (
              <DependentCard
                key={dep?.id || i}
                dependent={dep}
                onNavigate={onNavigate}
                detailsRoute={detailsRoute}
                selectedDependentId={selectedDependentId}
                refreshList={refreshList}
                isQuotaFull={isQuotaFull}
                isQuotaExceeded={isQuotaExceeded}
                shouldDisable={shouldDisable}
                activationFee={activationFee}
                excemptAllFee={excemptAllFee}
                onStatusError={(msg) => setPageError(msg)}
                subscription={subscription}
                currentCount={currentCount}
                userSubscriptionAllDetails={userSubscriptionAllDetails}
                billingScreenHandle={billingScreenHandle}
                checkQuotaAndShowPopup={checkQuotaAndShowPopup}
              />
            ))}
          </div>
        )}
      </div>

      <PopUpWelcomeAdvocord
        popUpStatus={isPopUp}
        dependent={dependent}
        userInfo={userInfo}
        hidePopUp={hidePopUp}
        closePopUP={closePopUP}
        popUpType={popUpType}
        totalAllowed={totalAllowed}
        currentCount={currentCount}
      />

      <PopUpQuikConsult
        popUpStatus={isPopUpQuickConsult}
        hidePopUp={hidePopUpQuickConsult}
      />

      <PopUpUserSurvey
        popUpStatus={IsSurveyRolePopUp}
        dependent={dependent}
        IsSurvey_PopUp={IsSurvey_PopUp}
        surveySectionVisible={surveySectionVisible}
        hideSurveyPopUp={skipSurveyPopUp}
        skipSurveyPopUp={skipSurveyPopUp}
        handleSurvey={onHandleSurvey}
        popUpType={popUpType}
      />

      <PopUpComponent
        popUpStatus={showPaymentWarning}
        title="Invalid Payment Method"
        message="Your current payment information is not correct. Please add a valid payment method to continue."
        buttonDeleteTxt="Continue"
        buttonCancelTxt="Cancel"
        handleDeleteButton={() => {
          setShowPaymentWarning(false);
          if (billingScreenHandle) {
            billingScreenHandle();
          } else {
            onNavigate(null, A12Y_CONST.ROUTE.ADVOCATE_PROFILE_MY_ACCOUNT);
          }
        }}
        hidePopUp={() => setShowPaymentWarning(false)}
      />

      <PopUpComponent
              popUpStatus={showCancelSubscriptionAtWindowEndPopup}
              title="Cancel Subscription"
              message={`Your subscription will remain active until ${moment(subscription?.subscription_details?.renewal_date).format('MMMM D, YYYY')}. After this date, it will not renew and your access will end.`}
              buttonDeleteTxt="Continue"
              buttonCancelTxt="Cancel"
              handleDeleteButton={() => {
                setShowCancelSubscriptionAtWindowEndPopup(false);
                if (billingScreenHandle) {
                  billingScreenHandle(true);
                } 
              }}
              hidePopUp={() => setShowCancelSubscriptionAtWindowEndPopup(false)}
            />

    </>
  );
}

export default AllDependentsDashboardComponent;
